import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-7441b422");

var _hoisted_1 = {
  class: "dialog-info-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 0,
  class: "commodity-list"
};
var _hoisted_4 = {
  class: "list-wrapper"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/close.png!w480?v=1",
  alt: ""
}, null, -1);

var _hoisted_6 = [_hoisted_5];

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_invitationItem = _resolveComponent("invitationItem");

  var _component_van_loading = _resolveComponent("van-loading");

  var _component_van_empty = _resolveComponent("van-empty");

  var _component_van_list = _resolveComponent("van-list");

  var _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_overlay, {
    show: $props.show,
    "z-index": "3"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString($options.titleInfo), 1), _createVNode(_component_van_list, {
        modelValue: $data.loading,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.loading = $event;
        }),
        finished: $data.finished,
        onLoad: $options.onLoad
      }, {
        default: _withCtx(function () {
          return [$data.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item) {
            return _openBlock(), _createBlock(_component_invitationItem, {
              item: item
            }, null, 8, ["item"]);
          }), 256))])])) : $data.loading ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 1,
            type: "spinner",
            class: "loading"
          })) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 2,
            class: "custom-image",
            image: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/content-null.png!w480",
            description: "暂无邀请记录～"
          }))];
        }),
        _: 1
      }, 8, ["modelValue", "finished", "onLoad"]), _createElementVNode("div", {
        class: "img--wrapper modal-close",
        onClick: _cache[1] || (_cache[1] = function () {
          return $options.onClickClose && $options.onClickClose.apply($options, arguments);
        })
      }, _hoisted_6)])];
    }),
    _: 1
  }, 8, ["show"])]);
}